import { getDefaultClient } from '../../factory';
// @endpoint POST /api/context/user-token
// @controller BusinessHooks.GetContextUserToken
export async function getContextUserToken() {
    return getDefaultClient().post('/context/user-token');
}
